import React, { useEffect, useState } from "react";
import "./css/characterDesingModal.css";
import PropTypes from "prop-types";
import ModalContent from "../modalContent/modalContent";
import ModalContentCharacter from "../modalContentCharacter/modalContentCharacter";

const CharacterDesingModal = ({ book, onClose, character = false }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setTimeout(() => setVisible(true), 10);
  }, []);

  const handleClose = () => {
    setVisible(false);
    setTimeout(onClose, 300);
  };

  if (!book) return null;
  return (
    <>
      <div
        className={`modal-backdrop fade ${visible ? "show" : ""}`}
        onClick={handleClose}
      />

      <div
        className={`modal fade slide-from-top ${
          visible ? "show d-block" : "d-block"
        }`}
        tabIndex="-1"
        role="dialog"
        aria-modal="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content modal-character-hv">
            <div className="modal-header border-0">
              <button
                type="button"
                className="btn-close"
                onClick={handleClose}
              />
            </div>

            <div className="modal-body d-flex justify-content-center align-items-center">
              {character ? (
                <ModalContentCharacter image={book.img} title={book.title} />
              ) : (
                <ModalContent
                  image={book.img}
                  title={book.title}
                  publisher={book.publisher}
                  country={book.country}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

CharacterDesingModal.propTypes = {
  book: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  character: PropTypes.bool,
};

export default CharacterDesingModal;
